export const globalConfig = {
	useRag: false,
	ncodeAllocationSection: 10
}